import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import {addTenantToQuery} from 'core/common/utils/utils';
import securityService from 'core/security/securityService';
import {PERMISSION, MODULE, SECURABLE_TYPE, ISECURABLE} from "core/metamodel/metaConstant";
import MenuItem from 'material-ui/MenuItem';
import {observer} from "mobx-react";
import {grey600} from "material-ui/styles/colors";

/* **************************************************************************************
 *******     MdIconButton     *******************************************************
 ****************************************************************************************/

const MdIconButton__styleOnToolbar = {width: 40, height: 40, padding: 8};
const MdIconButton_iconStyle = {color: grey600};

interface MdIconButtonProps {
  tooltip?: string;
  fontIcon?: string;
  style?: any;
  iconStyle?: any;
  onClick?: any;
  className?: string;
  disabled?: boolean;
  onToolbar?: boolean;
  children?: any;
}
export const MdIconButton = ({tooltip, fontIcon, style, iconStyle, onClick, className, disabled, onToolbar, children}: MdIconButtonProps) => (
  <IconButton onClick={onClick} tooltip={tooltip} disabled={disabled} className={className}
              style={ (onToolbar && style) ? Object.assign({}, MdIconButton__styleOnToolbar, style) : ( onToolbar ? MdIconButton__styleOnToolbar : style ) }
              iconStyle={ iconStyle ? Object.assign({}, MdIconButton_iconStyle, iconStyle) : MdIconButton_iconStyle}>
    {children}
  </IconButton>
);



/* **************************************************************************************
 *******     ZzIconButtonRoute     *******************************************************
 ****************************************************************************************/

const ZzIconButtonRoute__style = {width: 40, height: 40, padding: 8};
const ZzIconButtonRoute__iconStyle = {width: 18, height: 18, color: grey600};
const ZzIconButtonRoute__iconStyleBig = {width: 24, height: 24, color: grey600};

interface ZzIconButtonRouteProps {
  tooltip?: string;
  routeName?: string;
  params?: any;
  query?: any;
  style?: any;
  iconStyle?: any;
  disabled?: boolean;
  big?: boolean;
  module?: MODULE;
  securableType?: SECURABLE_TYPE;
  securable?: string|ISECURABLE;
  permission?: PERMISSION;
  children?: any;
}

export class ZzIconButtonRoute extends React.Component<ZzIconButtonRouteProps, undefined> {
  static contextTypes = {
    router: PropTypes.func.isRequired
  };

  onClick = (event) => {
    event.preventDefault();
    const {routeName, params, query} = this.props;
    this.context.router.transitionTo(routeName, params, query);
  };


  render() {
    const {tooltip, routeName, params, query, style, iconStyle, disabled, big, module, securableType, securable, permission, children} = this.props;

    if (!securityService.hasRouterRight(this.context.router, module, securableType, securable, permission)) {
      return <noscript/>
    }

    const _iconStyle = (big) ? ZzIconButtonRoute__iconStyleBig : ZzIconButtonRoute__iconStyle;

    return (disabled) ? (
      <IconButton tooltip={tooltip} disabled style={ style ? Object.assign({},ZzIconButtonRoute__style, style) : ZzIconButtonRoute__style}
                  iconStyle={ iconStyle ? Object.assign({}, _iconStyle, iconStyle) : _iconStyle}>
        {children}
      </IconButton>
    ) : (
      <a href={this.context.router.makeHref(routeName, params, addTenantToQuery(query))} onClick={this.onClick}>
        <IconButton tooltip={tooltip} style={Object.assign({},ZzIconButtonRoute__style, style)}
                    iconStyle={ iconStyle ? Object.assign({}, _iconStyle, iconStyle) : _iconStyle}>
          {children}
        </IconButton>
      </a>
    );

  }

}




/* **************************************************************************************
 *******     ZzIconButtonMenu     *******************************************************
 ****************************************************************************************/

type ZzMenuItemProps = {securable?: ISECURABLE, permission?: PERMISSION} & {[label:string]:any};

export const ZzMenuItem = ({securable, permission, ...other}: ZzMenuItemProps) => (<MenuItem {...other} />);


const ZzIconButtonMenu__style = {width: 40, height: 40, padding: 8};
const ZzIconButtonMenu__iconStyle = {color: grey600};
const ZzIconButtonMenu__anchorOrigin = {horizontal: 'left', vertical: 'top'};
const ZzIconButtonMenu__styleOverride = {fontSize: 14, lineHeight: '40px'};

interface ZzIconButtonMenuProps {
  buttonTooltip?: string;
  buttonIcon?: any;
  children?: any;
  disabled?: boolean;
  onClick?: any;
  style?: any;
  iconButtonStyle?: any;
  iconStyle?: any;
  securableType?: SECURABLE_TYPE;
}


@observer
export class ZzIconButtonMenu extends React.Component<ZzIconButtonMenuProps, undefined> {
  static contextTypes = {
    router: PropTypes.func.isRequired
  };


  render() {
    const {buttonTooltip, buttonIcon, children, disabled, onClick, style, iconButtonStyle, iconStyle, securableType} = this.props;

    let prunedChildren = React.Children.toArray(children).filter( (child: any) => {
      return !securableType || !child || !child.props || !child.props.securable || securityService.hasRouterRight(this.context.router, child.props.securable.module, securableType, child.props.securable.name, (child.props.permission)? child.props.permission : PERMISSION.Execute );
    });

    return (!prunedChildren.length && !onClick) ? <noscript/> : (
      <IconMenu iconButtonElement={<IconButton tooltip={buttonTooltip} disabled={disabled}
                                               style={ iconButtonStyle ? Object.assign({},ZzIconButtonMenu__style, iconButtonStyle) : ZzIconButtonMenu__style}
                                               iconStyle={ iconStyle ? Object.assign({}, ZzIconButtonMenu__iconStyle, iconStyle) : ZzIconButtonMenu__iconStyle}>
        {buttonIcon}
      </IconButton>}
                style={style}
                onClick={onClick}
                useLayerForClickAway={true}
                anchorOrigin={ZzIconButtonMenu__anchorOrigin as any}
                targetOrigin={ZzIconButtonMenu__anchorOrigin as any}
      >
        {
          prunedChildren.map((child: any, index) => {
            let {style, securable, permission, ...other} = child.props;
            return React.cloneElement(
              child,
              {
                key: index,
                style: Object.assign({}, ZzIconButtonMenu__styleOverride, child.props.style),
                ...other
              }
            );
          })
        }
      </IconMenu>
    )
  }

}




// WEBPACK FOOTER //
// ./src/core/components/buttons/icons.tsx